<template></template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      sprite: null,
      showAuxil: false,
      auxiliary: null,
      spinLine: null,
      netLine: null,
      spinLineData: {
        width: 500,
        height: 500,
        top: 500,
        left: 500
      }
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'Tool_Size',
      'SelectSprites_Msg',
      'SelectScenes_Msg'
    ])
  },
  mounted () {
    this.auxiliary = null;
    this.spinLine = null;

    eve.on('multiAdsorb', (data) => {
      this.showNetLine(data)
    });
    eve.on('SelectSprites_process_up', (data) => {
      if(this.netLine && this.netLine.length){
        this.netLine.forEach( k => {
          k.hide()
        });
      }
    });
  },
  watch: {
    'SelectSprites_Msg': function(val, oldVal) {
      if (this.TOOL.adsorb && this.SelectSprites_Msg && this.SelectSprites_Msg.length === 1) {
        this.sprite = this.SelectSprites_Msg[0]
      } else {
        this.showAuxil = false;
        this.spinLine.hide();
        this.netLine.forEach( k => {
          k.hide()
        })
      }
    },
    'TOOL': function() {
      if(!this.auxiliary && this.TOOL) {
        this.createDomBox()
      }
    },
    'sprite.action':function(val,oldVal) {
      if(!this.sprite) {
        this.showAuxil = false;
        this.spinLine.hide();
        this.netLine.forEach( k => {
          k.hide()
        })
      }
      if(val) {
        if(val === 'spin') {
          this.showAuxil = true;
          this.calcSpinData();
        }else {
          this.showAuxil = true;
          this.SelectScenes_Msg._getAdsorbArr()
        }
      } else {
        this.showAuxil = false;
        this.spinLine.hide();
        this.netLine.forEach( k => {
          k.hide()
        })
      }
    },
    'sprite.adsorbData': function(val, oldVal) {
      this.showAuxil && this.showNetLine(val)
    }
  },
  methods: {
    createDomBox() {
      this.auxiliary = $('<div></div>').attr({
        id: 'handle_auxiliary_line_box'
      })
      this.createSpinLine()
      this.createNetLine()
      this.auxiliary.appendTo(this.TOOL.handle)
    },
    createSpinLine() {
      this.spinLine = $('<div id="auxiliary_line_spin_box"></div>')
        .append([$('<div class="spin_line_level"></div>'), 
                $('<div class="spin_line_vertical"></div>'), 
                $('<div class="spin_line_tile"></div>'),
                $('<div class="spin_line_tile_t"></div>')])
        .appendTo(this.auxiliary)
        .hide()
    },
    createNetLine() {
      this.netLine = [
        $('<div class="net_line_top"></div>').hide(),
        $('<div class="net_line_right"></div>').hide(),
        $('<div class="net_line_bottom"></div>').hide(),
        $('<div class="net_line_left"></div>').hide(),
        $('<div class="net_line_middle"></div>').hide(),
        $('<div class="net_line_center"></div>').hide(),
      ]
      $('<div id="auxiliary_line_net_box"></div>').append(this.netLine).appendTo(this.auxiliary)
    },
    calcSpinData() {
      if(!this.TOOL.adsorb) {
        this.spinLine.hide();
        return;
      }
      this.spinLineData.width = this.spinLineData.height = Math.max(this.sprite.width, this.sprite.height) * 1.6;
      this.spinLineData.top = this.sprite.positionTop - (this.spinLineData.height - this.sprite.height) / 2;
      this.spinLineData.left = this.sprite.positionLeft - (this.spinLineData.width - this.sprite.width) / 2;
      this.spinLine.css(this.spinLineData).show();
    },
    showNetLine(arr) {
      // 显示元素变化时的辅助线
      arr.forEach((val, i) => {
        if(val.v) {
          if((i+2)%2 === 0) {
            this.netLine[i].css({
              top: val.v
            }).show()
          } else {
            this.netLine[i].css({
              left: val.v
            }).show()
          }
        }else {
          this.netLine[i].hide()
        }
      })
    }
  }
}
</script>

<style lang="scss">
#handle_auxiliary_line_box {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 15;
  box-sizing: border-box;
}
#auxiliary_line_spin_box {
  position: absolute;
  top: 0;
  left: 0;

  .spin_line_level,.spin_line_vertical,.spin_line_tile,.spin_line_tile_t{
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 100%;
    border-top: 1px solid #fff;
    transform-origin: center top;
    opacity: .8;

    &::before {
      position: absolute;
      display: block;
      content: '';
      border-top: 1px dashed #00ffff;
      height: 100%;
      width: 100%;
      margin: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
  .spin_line_vertical {
    transform: rotate(90deg);
  }
  .spin_line_tile {
    transform: rotate(45deg);
  }
  .spin_line_tile_t {
    transform: rotate(-45deg);
  }
}
#auxiliary_line_net_box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  div {
    position: absolute;
    opacity: .6;
  }

  div:nth-child(even) {
    height: 100%;
    width: 1px;
    border-left: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: '';
      border-left: 1px dashed #00ffff;
      height: 100%;
      width: 1px;
      left: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
  div:nth-child(odd) {
    width: 100%;
    height: 1px;
    border-top: 1px solid #fff;

    &::before {
      position: absolute;
      display: block;
      content: '';
      border-top: 1px dashed #00ffff;
      height: 1px;
      width: 100%;
      top: -1px;
      box-sizing: content-box;
      pointer-events: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/auxiliaryLine.vue